import { render } from "./sdgd.vue?vue&type=template&id=07b0cbfa&scoped=true&ts=true"
import script from "./sdgd.vue?vue&type=script&lang=ts"
export * from "./sdgd.vue?vue&type=script&lang=ts"

import "./sdgd.vue?vue&type=style&index=0&id=07b0cbfa&lang=less&scoped=true"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b0cbfa"]])

export default __exports__